// @vendors
import { useContext, useEffect, useState } from "react"
import { Form, Radio } from 'antd'
import Context from '../../../context/appContext';
import { fieldToClear, getDependencyValue, getValueField } from '../../../utils/utils';

// @styles
import './styles.scss';

export default function RadioButton({ info, key, form, current }) {
    const validate = info.validate ? info.validate : {};
    const { dataForm: { data, formResponses, hiddenFields, disabledFields }, setDataForm } = useContext(Context);

    useEffect(() => { info && info.values && getDefaultValue() }, []);


    const onChange = (event) => {
        form.resetFields(fieldToClear)        
        setValue(event);
        const dependencyValue = getDependencyValue(current, info.key, event.target.value, []);
        if (dependencyValue && dependencyValue.length > 0) {
            dependencyValue.forEach(item => {
                const keyLcl = Object.keys(item)[0];
                hiddenFields[keyLcl] = item[keyLcl];
            });
            setDataForm({ data, formResponses, hiddenFields: hiddenFields, disabledFields });
        }
        // info && info.key === 'tipoDePersonaAsegurado' && form.resetFields(['razonSocialAsegurado']);
        info && info.key === 'tipoDePersonaContratante' && form.resetFields(["regimenFiscalContratante"]);
    }

    const setValue = (event) => {
        info.value = event.target.value;
        const index = formResponses.findIndex(x => x.key === info.key);
        index != -1 ? formResponses[index].value = event.target.value : formResponses.push(info);
    }


    const getDefaultValue = () => {
        if (info && info.value && info.value !== null && info.value !== '') {
            form.setFieldsValue({ [info.key]: info.value });
            onChange({ target: { value: info.value } });
        } else {
            const index = formResponses.findIndex(x => x.key === info.key);
            let value = index != -1 ? formResponses[index].value : '';
            value = value ? value : info.defaultValue;
            form.setFieldsValue({ [info.key]: value });
            onChange({ target: { value: value } });

        }
    }

    return (
        <>
            <div className="contractor-info">
                <Form.Item
                    className='ant-form-item-normal'
                    label={info && info.key !== 'tipoDePersonaAsegurado' && info.label}
                    name={info.key}
                    key={key}
                    hidden={hiddenFields[info.key]}
                    rules={[
                        {
                            required: hiddenFields[info.key] || disabledFields[info.key] || info.disabled ? false : validate.required,
                            message: 'Este campo es requerido'
                        }
                    ]}
                >
                    <Radio.Group
                        className='radiobutton'
                        disabled={false}
                        onChange={onChange}
                    >
                        {info && info.values && info.values.map((item, index) => (
                            <Radio
                                className="radiobutton__item"
                                value={item.value}
                                key={`radio-option-${index}`}
                                data-testid={`radio-option-${index}`}
                            >
                                <em className="fas fa-braille" />
                                <p>{item.label}</p>
                            </Radio>
                        ))}
                    </Radio.Group>
                </Form.Item>
            </div>
        </>
    )
}